import React, { createContext, useContext, useMemo } from "react";
import {
    REPORT_PRIMARY_COLOR,
    REPORT_PRIMARY_TEXT_COLOR,
    resolveBranding,
    resolveLogo,
} from "../helpers";

const BrandingContext = createContext({
    primaryColor: REPORT_PRIMARY_COLOR,
    stopColor: REPORT_PRIMARY_COLOR,
    sectionHeaderColor: REPORT_PRIMARY_COLOR,
    textOnPrimary: REPORT_PRIMARY_TEXT_COLOR,
    logo: { src: null, size: {} },
});

export const BrandingProvider = ({ organization, children }) => {
    const value = useMemo(() => {
        const branding = resolveBranding(organization);

        return {
            ...branding,
            logo: resolveLogo(organization),
        };
    }, [organization]);

    return (
        <BrandingContext.Provider value={value}>
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => useContext(BrandingContext);
